/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as ShippingAddressFormLoader } from './ShippingAddressForm/ShippingAddressForm.duck';

const getCompDataLoadingAPI = () => {
  return {
    ShippingAddressForm: {
      loadData: ShippingAddressFormLoader,
    },
  };
};

export default getCompDataLoadingAPI;
